angular.module('offlineChecker')
.filter('vehicleRegistrationFilter', vehicleRegistrationFilter);

function vehicleRegistrationFilter(){
    return function(reservations, roomVehRegIndex, guestVehRegIndex, searchFor){
        if(!Array.isArray(reservations)){
            return reservations;
        }
        if(typeof roomVehRegIndex !== "number"){
            return reservations;
        }
        if(typeof guestVehRegIndex !== "number"){
            return reservations;
        }
        if(reservations.length === 0){
            return reservations;
        }
        if(roomVehRegIndex >= reservations[0].length){
            return reservations;
        }
        if(guestVehRegIndex >= reservations[0].length){
            return reservations;
        }
        if(!(roomVehRegIndex >= 0)){
            return reservations;
        }
        if(!(guestVehRegIndex >= 0)){
            return reservations;
        }
        roomVehRegIndex -= (roomVehRegIndex % 1); // fix for floats being passed in
        guestVehRegIndex -= (guestVehRegIndex % 1);
        if(typeof searchFor === 'string'){
            var out = [];
            angular.forEach(reservations, function(reservation){
                var searchAgainst = reservation[roomVehRegIndex];
                searchAgainst = (searchAgainst) ? searchAgainst : reservation[guestVehRegIndex];
                if(searchFor){
                    if(searchAgainst !== null){
                        if(searchAgainst.toString().toLowerCase().indexOf(searchFor.toLowerCase()) > -1){
                            out.push(reservation);
                        }
                    }
                } else {
                    out.push(reservation);
                }
            });
            return out;
        } else {
            return reservations;
        }
    }
}